import apiService from 'config/service';
import { Payload, PayloadValidateFields } from './types';

const postRisk = (payload: Payload) =>
  apiService.post(`freights/accept`, payload);

const validateFields = (payload: PayloadValidateFields) =>
  apiService.post('freights/risk-validate-owner', payload);

export { postRisk, validateFields };
